import { Component } from 'base/js/aem';
import { ScrollSpy } from 'bootstrap';

class AnchorBar extends Component {
    init() {
        const props = this.props;

        if (!props.cmpLocalNav) {
            this.initScrollSpy();
        } else {
            this.highlightActivePage();
        }

        // Dropdown menu functionality
        this.anchorTitle = this.element.querySelector('.navbar-anchor-bar');
        this.anchorNav = this.element.querySelector('.anchor-bar-menu');
        this.anchorLink = this.element.querySelectorAll('a.anchor-bar-link');

        this.anchorTitle.addEventListener('click', this);
        this.anchorTitle.addEventListener('keyup', this);

        this.anchorLink.forEach(item => {
            item.addEventListener('click', this);
        });
    }

    handleEvent(e) {
        const ENTER = 13;
        const SPACE = 32;

        if (e.type === 'click') {
            this.handleToggle();
        } else if (e.type === 'keyup' && (e.keyCode === ENTER || e.keyCode === SPACE)) {
            this.handleToggle();
        }
    }

    handleToggle() {
        this.anchorTitle.classList.toggle('active');
        this.anchorNav.classList.toggle('active');
    }

    initScrollSpy() {
        // ScrollSpy functionality
        const TOP = 60;
        const VERTICAL_OFFSET = 118;
        const anchorBar = this.element.querySelector('.menu-container');
        const cmpAnchorBar = this.element.parentNode;
        const anchorBarOffset = cmpAnchorBar?.classList.contains('vertical-anchor-bar') ? VERTICAL_OFFSET : anchorBar.offsetHeight + TOP;
        /* eslint-disable no-unused-vars */
        const scrollSpy = new ScrollSpy(document.body, {
            target: '[data-component="anchor-bar"]',
            offset: anchorBarOffset
        });
        /* eslint-enable no-unused-vars */
    }

    highlightActivePage() {
        const currentPage = new URL(window.location.href);
        const pageRelativeUrl = this.cleanPath(currentPage.pathname);
        const anchorLinks = this.element.querySelectorAll('a.anchor-bar-link');
        const urlRegex = /^(https?:\/\/)/;

        anchorLinks.forEach(link => {
            const linkUrl = this.cleanPath(link.getAttribute('href'));
            const match = linkUrl.match(urlRegex);
            let relativeLinkUrl = linkUrl;

            if (match) {
                relativeLinkUrl = new URL(linkUrl).pathname;
            }

            if (relativeLinkUrl === pageRelativeUrl) {
                link.classList.add('active');
            }
        });
    }

    cleanPath(path) {
        return path.replace(/\/content\/amd\/(live-site|language-masters)\//g, '/');
    }
}

export { AnchorBar };
